export class TokenService {
  private static ACCESS_TOKEN_KEY = "accessToken";

  private static REFRESH_TOKEN_KEY = "refreshToken";

  private static REMEMBER_ME_KEY = "rememberMe";

  private static DISTRICT_ID = "districtId";

  static setTokens(accessToken: string, refreshToken: string, isCardSession = false) {
    if (typeof window !== "undefined") {
      const storage = isCardSession ? sessionStorage : localStorage;
      storage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
      storage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
      localStorage.setItem(this.REMEMBER_ME_KEY, isCardSession ? "false" : "true");
    }
  }

  static setDistrictId(districtId: string) {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      storage.setItem(this.DISTRICT_ID, districtId);
    }
  }

  static updateAccessToken(accessToken: string) {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      storage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
    }
  }

  static isRememberedSession(): boolean {
    if (typeof window !== "undefined") {
      return localStorage.getItem(this.REMEMBER_ME_KEY) === "true";
    }
    return false;
  }

  static getAccessToken(): string | null {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      return storage.getItem(this.ACCESS_TOKEN_KEY);
    }
    return null;
  }

  static getRefreshToken(): string | null {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      return storage.getItem(this.REFRESH_TOKEN_KEY);
    }
    return null;
  }

  static getDistrictId(): string | null {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      return storage.getItem(this.DISTRICT_ID);
    }
    return null;
  }

  static clearTokens() {
    if (typeof window !== "undefined") {
      const storage = this.isRememberedSession() ? localStorage : sessionStorage;
      storage.removeItem(this.ACCESS_TOKEN_KEY);
      storage.removeItem(this.REFRESH_TOKEN_KEY);
      storage.removeItem(this.DISTRICT_ID);
      localStorage.removeItem(this.REMEMBER_ME_KEY);
    }
  }

  static decodeToken(token: string): { email?: string } {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return { email: payload.email };
    } catch (error) {

      console.error("Invalid token:", error);
      return {};
    }
  }
}
